const ReadOnly = {    
    install(Vue) {
        Vue.mixin({          
            directives: {                
                readOnly: {                
                    inserted: function (el, payLoad, vnode) {
                        let appState = vnode.context.$store.state;
                        let user = appState.auth.user;    
                        let resourceLowerCase = payLoad.value.resource.toLowerCase();
                        let rolePermissionData = appState.rolePermissions.rolePermissionData;
                        let permissionDataItem = rolePermissionData.filter(r=> r.resource.toLowerCase() == resourceLowerCase);
                        if(permissionDataItem && permissionDataItem.length > 0) {
                            var items = permissionDataItem[0].roles.map(a => a.toLowerCase());
                            if(items.some(x => user.roles.some(y => y.displayName.toLowerCase() == x))) {
                                el.disabled = false;
                            } else {
                                el.disabled = true;
                            }                    
                         }                                                   
                    }
                }
            },
      });
    }    
  };

  export default ReadOnly;